// extracted by mini-css-extract-plugin
export default {"header":"headerxBdiJ","heading":"headingbToGa"};